/* tslint:disable */
/* eslint-disable */
/* @relayHash db188047b30bb9d33f6758afd61c6ec3 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ActiveMembershipsQueryVariables = {
    classroomId: string;
    count: number;
    cursor?: string | null;
};
export type ActiveMembershipsQueryResponse = {
    readonly classroom: {
        readonly " $fragmentRefs": FragmentRefs<"ActiveMemberships_classroom">;
    } | null;
};
export type ActiveMembershipsQuery = {
    readonly response: ActiveMembershipsQueryResponse;
    readonly variables: ActiveMembershipsQueryVariables;
};



/*
query ActiveMembershipsQuery(
  $classroomId: ID!
  $count: Int!
  $cursor: String
) {
  classroom: node(id: $classroomId) {
    __typename
    ... on Classroom {
      ...ActiveMemberships_classroom_1G22uz
    }
    id
  }
}

fragment ActiveMemberships_classroom_1G22uz on Classroom {
  id
  activeMemberships(first: $count, after: $cursor) {
    edges {
      node {
        id
        ...ClassroomMember_classroomMembership
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ClassroomMember_classroomMembership on ClassroomMembership {
  id
  level
  user {
    username
    id
  }
  classroom {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "classroomId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "classroomId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ActiveMembershipsQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "classroom",
        "name": "node",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "type": "Classroom",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ActiveMemberships_classroom",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                  },
                  {
                    "kind": "Variable",
                    "name": "cursor",
                    "variableName": "cursor"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ActiveMembershipsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "classroom",
        "name": "node",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "Classroom",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activeMemberships",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "ClassroomMembershipConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClassroomMembershipEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClassroomMembership",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "level",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "username",
                                "args": null,
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "classroom",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Classroom",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "activeMemberships",
                "args": (v4/*: any*/),
                "handle": "connection",
                "key": "ActiveMemberships_activeMemberships",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ActiveMembershipsQuery",
    "id": null,
    "text": "query ActiveMembershipsQuery(\n  $classroomId: ID!\n  $count: Int!\n  $cursor: String\n) {\n  classroom: node(id: $classroomId) {\n    __typename\n    ... on Classroom {\n      ...ActiveMemberships_classroom_1G22uz\n    }\n    id\n  }\n}\n\nfragment ActiveMemberships_classroom_1G22uz on Classroom {\n  id\n  activeMemberships(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        ...ClassroomMember_classroomMembership\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ClassroomMember_classroomMembership on ClassroomMembership {\n  id\n  level\n  user {\n    username\n    id\n  }\n  classroom {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '24c0e2835dbe97e6c02d71618a729706';
export default node;
